import dateFormat from "dateformat";

export function getAgeInYears(dateOfBirth: Date): number {
  if (!dateOfBirth || !dateOfBirth.getTime()) {
    return 0;
  }
  const today = new Date();

  const yearDiff = today.getFullYear() - dateOfBirth.getFullYear();

  const isDateAndMonthOnOrAfter =
    today.getMonth() > dateOfBirth.getMonth() ||
    (today.getMonth() === dateOfBirth.getMonth() &&
      today.getDate() >= dateOfBirth.getDate());

  const ageInYears = isDateAndMonthOnOrAfter ? yearDiff : yearDiff - 1;

  return ageInYears;
}

export function getAge(dateOfBirth: Date) {
  if (!dateOfBirth || !dateOfBirth.getTime()) {
    return "";
  }
  const today = new Date();

  const yearDiff = today.getFullYear() - dateOfBirth.getFullYear();

  const monthDiff = today.getMonth() - dateOfBirth.getMonth();

  const isDateAndMonthOnOrAfter =
    today.getMonth() > dateOfBirth.getMonth() ||
    (today.getMonth() === dateOfBirth.getMonth() &&
      today.getDate() >= dateOfBirth.getDate());

  const ageInYears = isDateAndMonthOnOrAfter ? yearDiff : yearDiff - 1;

  return `${ageInYears}y${monthDiff > 0 ? `, ${monthDiff}m` : ""}`;
}

export function isSameDay(d1: Date, d2: Date) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

export const getTimeDiff = (startDate: Date, endDate: Date) => {
  var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
  const hours = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, "0");
  const minutes = (Math.floor(seconds / 60) % 60).toString().padStart(2, "0");
  const sec = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");

  return `${hours}:${minutes}:${sec}`;
};

export const getSampleDate = (schedule: string) => {
  if (schedule.includes("Day")) {
    const [_, day] = schedule.split(" ");
    const requiredDate = new Date();

    requiredDate.setDate(requiredDate.getDate() + (Number(day) - 1));

    return dateFormat(requiredDate, "d mmmm, yyyy");
  } else if (schedule.includes("Week")) {
    const [_, week] = schedule.split(" ");
    const requiredDate = new Date();

    requiredDate.setDate(requiredDate.getDate() + (Number(week) - 1) * 7);

    return dateFormat(requiredDate, "d mmmm, yyyy");
  } else if (schedule.includes("Month")) {
    const [_, month] = schedule.split(" ");
    const requiredDate = new Date();

    requiredDate.setDate(requiredDate.getDate() + (Number(month) - 1) * 30);

    return dateFormat(requiredDate, "d mmmm, yyyy");
  } else {
    return "-";
  }
};

export const getDateObjectFromYYYYMMDDWithTimezoneAdjusted = (
  dateString: string
) => {
  const dateObject = new Date(dateString);
  const currentTimezoneOffset = dateObject.getTimezoneOffset();

  return new Date(dateObject.getTime() + currentTimezoneOffset * 60 * 1000);
};

export function isStrictISODateTimeString(dateString: string): boolean {
  const strictIsoDateTimeRegex =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
  return strictIsoDateTimeRegex.test(dateString);
}
